import React from 'react';
import { Provider } from 'react-redux';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';

import 'antd/dist/reset.css';
import 'react-json-view-lite/dist/index.css';
import './App.css';

import store from './app/store';
import { ThemeProvider } from './app/ThemeProvider';
import { RequireAdmin, RequireModule } from './components';

import LoginPage from './pages/unauthorized/login';
import ImpersonatePage from './pages/unauthorized/impersonate';
import { NewFinancesPage } from './pages/authorized/finances-v2';
import { UsersyncStatisticsPage } from './pages/authorized/usersync-statistics';
import { PredictionsPage } from './pages/authorized/predictions-v2';
import CompaniesPage from './pages/authorized/companies';
import { DspsV2Page } from './pages/authorized/dsps';
import DSPPage from './pages/authorized/dsp';
import { SspsPage } from './pages/authorized/ssps';
import SSPPage from './pages/authorized/ssp';
import EventLogsPage from './pages/authorized/eventLogs';
import ListsPage from './pages/authorized/lists';
import Settings from './pages/authorized/settings';
import DataSamplePage from './pages/authorized/data-sample';
import SwapperBulkManagerPage from './pages/authorized/swapper-bulk-manager';
import DocumentationPage from './pages/authorized/documentation';
import UserManagementPage from './pages/authorized/userManagement';
import { ResponseTimePage } from './pages/authorized/response-time';
import { AuthLayout } from './layouts/AuthLayout';

// The platform admin panel opens this whether or not someone is already signed in on this browser
const impersonateRoute = { path: '/impersonate', element: <ImpersonatePage /> };

const unauthorizedRoutes = [{ path: '/', element: <LoginPage /> }, impersonateRoute];

const authorizedRoutes = [
  {
    path: '/',
    element: <AuthLayout />,
    children: [
      { path: '/', element: <Navigate to="/finances-v2" replace /> },
      { path: '/response-time', element: <ResponseTimePage /> },
      { path: '/statistics-v2', element: <Navigate to="/" replace /> },
      { path: '/node-health', element: <Navigate to="/" replace /> },
      { path: '/load-balancer', element: <Navigate to="/" replace /> },
      { path: '/exchanges', element: <Navigate to="/" replace /> },
      { path: '/finances', element: <Navigate to="/finances-v2" replace /> },
      { path: '/finances-v2', element: <NewFinancesPage /> },
      { path: '/usersync-statistics', element: <UsersyncStatisticsPage /> },
      {
        path: '/predictions',
        element: (
          <RequireModule module="overpay">
            <PredictionsPage />
          </RequireModule>
        ),
      },
      { path: '/companies', element: <CompaniesPage /> },
      { path: '/dsps', element: <DspsV2Page /> },
      { path: '/dsps/:id', element: <DSPPage /> },
      { path: '/ssps', element: <SspsPage /> },
      { path: '/ssps/:id', element: <SSPPage /> },
      { path: '/event-logs', element: <EventLogsPage /> },
      { path: '/lists/:title', element: <ListsPage /> },
      { path: '/settings', element: <Settings /> },
      { path: '/tools', element: <Navigate to="/data-sample" replace /> },
      { path: '/data-sample', element: <DataSamplePage /> },
      {
        path: '/swapper-bulk-manager',
        element: (
          <RequireAdmin>
            <RequireModule module="swapper">
              <SwapperBulkManagerPage />
            </RequireModule>
          </RequireAdmin>
        ),
      },
      { path: '/documentation', element: <DocumentationPage /> },
      { path: '/user-management', element: <UserManagementPage /> },
    ],
  },
  impersonateRoute,
];

const router = createBrowserRouter(
  window.localStorage.hasOwnProperty('accessToken') ? authorizedRoutes : unauthorizedRoutes
);

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <div className="App">
          <RouterProvider router={router} />
        </div>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
